<div class="wrapper page-header non-transparent-header">
    <div class="container">
        <div class="row">
            <div class="mx-auto">
                <div class="author text-center w-100 q-page-header">
                    <ng-container>
                        <h1 class="title vmb-3 q-page-header-title home-description member-login">Member Login</h1>
                        <p
                            class="underline-text-dark text-bold fs-4 vmb-3 home-description {{ isDesktop ? 'w-40' : 'w-100' }}">
                            Enter your mobile number or email address below to log into your Qatch account.
                        </p>
                        <i style="color:#8862a2">Not a member? <a style="color:#8862a2" [routerLink]="['/signup']"
                                class=" sign_in_sign_up" [queryParamsHandling]="'merge'">Sign up
                            </a></i>
                    </ng-container>
                </div>
                <div class="vmy-2 q-page-container">
                    <form class="register-form mx-auto" [formGroup]="authForm" (ngSubmit)="requestOTP($event)"
                        autocomplete="off" autocapitalize="off">
                        <div id="captcha-container"></div>
                        <div class="phone-input-section">
                            <label class="label vmt-3 required-field">Phone Number | Email</label>
                            <div class="input-group form-group-no-border bg-default shadow">
                                <span class="input-suffix" *ngIf="isPhone">{{countryCode}} </span>
                                <input type="text" class="form-control box-shadow-none" formControlName="username"
                                    placeholder="Enter Phone Number | Email">
                            </div>
                            <uikit-error [submitted]="false" [controls]="controls" name="username"
                                placeholder="{{isPhone ? 'Phone number' : 'Email'}}">
                            </uikit-error>
                        </div>

                        <div class="form-row justify-content-center">
                            <q-button title="Sign In" [disabled]="!authForm.valid || loading || otpRequested"
                                buttonStyleClass="btn-purple" iconStyleClass="btn-dark-purple" type="arrowButton"
                                [loading]="loading || otpRequested" class="vml-1 sign_in vmt-6 active"
                                (onBtnClick)="requestOTP($event);">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="loading || otpRequested"></span>
                            </q-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="top-left-img" *ngIf="isDesktop">
        <img src="./assets/img/organic/Shape-3.png" />
    </div>
    <div class="bottom-right-img" [class.low-opacity]="!isDesktop">
        <img src="./assets/img/organic/Shape-4.png" />
    </div>
</div>